import { PLAYER_TYPES } from '../../../constants/features'
import React from 'react'
import Player from './Player'

export { Player }
export default Object.fromEntries(
  PLAYER_TYPES.map(type => {
    const Enhanced = React.forwardRef((props, ref) => (
      <Player {...props} ref={ref} videoType={type} />
    ))
    return [type, Enhanced]
  })
)
